module.exports = __webpack_public_path__ + "img/before-3.6c4c9d84.png";